var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _rect3, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLemon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.221 179.04L107.248 179.701L110.385 217.572L118.358 216.911L115.221 179.04Z",
    fill: "#1F201D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.8 179.3H151.8V217.3H159.8V179.3Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 230,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 230,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.3 242.3C159.772 242.3 178.8 240.061 178.8 237.3C178.8 234.539 159.772 232.3 136.3 232.3C112.828 232.3 93.8 234.539 93.8 237.3C93.8 240.061 112.828 242.3 136.3 242.3Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.3 235.3C115.965 235.3 123.8 230.375 123.8 224.3C123.8 218.225 115.965 213.3 106.3 213.3C96.6351 213.3 88.8 218.225 88.8 224.3C88.8 230.375 96.6351 235.3 106.3 235.3Z",
    fill: "#1F201D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.3 235.3C173.965 235.3 181.8 230.375 181.8 224.3C181.8 218.225 173.965 213.3 164.3 213.3C154.635 213.3 146.8 218.225 146.8 224.3C146.8 230.375 154.635 235.3 164.3 235.3Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 217,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 217,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3 224.3C97.6808 224.3 98.8 223.181 98.8 221.8C98.8 220.419 97.6808 219.3 96.3 219.3C94.9193 219.3 93.8 220.419 93.8 221.8C93.8 223.181 94.9193 224.3 96.3 224.3Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 217,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 217,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.3 224.3C176.681 224.3 177.8 223.181 177.8 221.8C177.8 220.419 176.681 219.3 175.3 219.3C173.919 219.3 172.8 220.419 172.8 221.8C172.8 223.181 173.919 224.3 175.3 224.3Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6001 122.2C90.6001 122.2 70.9001 152.5 79.4001 174.4",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 206.1C133.6 206.1 133.6 206.1 133.7 206.1C130.9 207.8 127.5 208.6 124 208C119.8 207.3 116.3 204.9 114.2 201.6C91.4 181 80.1 152.1 85.3 109.6C90.6 67.1 132.2 56.8 136.5 54.2C140.8 51.6 143.9 47.4 143.9 47.4C146.1 40.9 152.7 36.7 159.7 37.8C165.9 38.8 170.5 43.5 171.6 49.3C173 53.4 182.2 67.7 182.2 67.7C207.2 98 200.4 133.8 200.4 133.8C194.2 190 134.6 205.9 133.7 206.1Z",
    fill: "#FBEA3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.6 206.2C130.8 207.9 127.4 208.7 123.9 208.1C121.8 207.8 119.8 207 118.1 205.9C119.3 205.5 120.5 205 121.6 204.4C122.5 204.2 182.2 188.3 188.3 132.2C188.3 132.2 195.1 96.4 170.1 66.1C170.1 66.1 161 51.8 159.5 47.7C158.8 43.9 156.6 40.6 153.4 38.4C155.3 37.8 157.5 37.7 159.6 38C165.8 39 170.4 43.7 171.5 49.5C173 53.6 182.1 68 182.1 68C207.1 98.3 200.3 134.1 200.3 134.1C194.2 190.2 134.5 206 133.6 206.2Z",
    fill: "#FCD728"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 126.4C193.5 126.4 213.5 113.4 210.5 93.4C210.5 93.4 217.5 83.4 213.5 74.4",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 85.4C201.5 85.4 203.5 95.4 210.5 93.4C217.5 91.4 223.7 88.4 222.1 78.9",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.3 135.3C111.89 135.3 114.8 132.39 114.8 128.8C114.8 125.21 111.89 122.3 108.3 122.3C104.71 122.3 101.8 125.21 101.8 128.8C101.8 132.39 104.71 135.3 108.3 135.3Z",
    fill: "#4C1A1D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.8 131.8C143.8 128.2 146.7 125.3 150.3 125.3C153.9 125.3 156.8 128.2 156.8 131.8",
    fill: "#4C1A1D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3 135.3C141.3 141.4 136.4 146.3 130.3 146.3C124.2 146.3 119.3 141.4 119.3 135.3",
    fill: "#4C1A1D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.6 157.1C151.981 157.1 153.1 155.981 153.1 154.6C153.1 153.219 151.981 152.1 150.6 152.1C149.219 152.1 148.1 153.219 148.1 154.6C148.1 155.981 149.219 157.1 150.6 157.1Z",
    fill: "#FCD728"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.1 142.1C180.481 142.1 181.6 140.981 181.6 139.6C181.6 138.219 180.481 137.1 179.1 137.1C177.719 137.1 176.6 138.219 176.6 139.6C176.6 140.981 177.719 142.1 179.1 142.1Z",
    fill: "#FCD728"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.1 108.1C180.481 108.1 181.6 106.981 181.6 105.6C181.6 104.219 180.481 103.1 179.1 103.1C177.719 103.1 176.6 104.219 176.6 105.6C176.6 106.981 177.719 108.1 179.1 108.1Z",
    fill: "#FCD728"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.1 125.1C157.481 125.1 158.6 123.981 158.6 122.6C158.6 121.219 157.481 120.1 156.1 120.1C154.719 120.1 153.6 121.219 153.6 122.6C153.6 123.981 154.719 125.1 156.1 125.1Z",
    fill: "#FCD728"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.3 184.3C116.681 184.3 117.8 183.181 117.8 181.8C117.8 180.419 116.681 179.3 115.3 179.3C113.919 179.3 112.8 180.419 112.8 181.8C112.8 183.181 113.919 184.3 115.3 184.3Z",
    fill: "#FCD728"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1001 139.1C96.4808 139.1 97.6001 137.981 97.6001 136.6C97.6001 135.219 96.4808 134.1 95.1001 134.1C93.7194 134.1 92.6001 135.219 92.6001 136.6C92.6001 137.981 93.7194 139.1 95.1001 139.1Z",
    fill: "#FCD728"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 118.1C108.481 118.1 109.6 116.981 109.6 115.6C109.6 114.219 108.481 113.1 107.1 113.1C105.719 113.1 104.6 114.219 104.6 115.6C104.6 116.981 105.719 118.1 107.1 118.1Z",
    fill: "#FCD728"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1001 102.1C95.4808 102.1 96.6001 100.981 96.6001 99.6C96.6001 98.2193 95.4808 97.1 94.1001 97.1C92.7194 97.1 91.6001 98.2193 91.6001 99.6C91.6001 100.981 92.7194 102.1 94.1001 102.1Z",
    fill: "#FCD728"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.1 107.1C137.481 107.1 138.6 105.981 138.6 104.6C138.6 103.219 137.481 102.1 136.1 102.1C134.719 102.1 133.6 103.219 133.6 104.6C133.6 105.981 134.719 107.1 136.1 107.1Z",
    fill: "#FCD728"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.1 83.1C121.481 83.1 122.6 81.9807 122.6 80.6C122.6 79.2193 121.481 78.1 120.1 78.1C118.719 78.1 117.6 79.2193 117.6 80.6C117.6 81.9807 118.719 83.1 120.1 83.1Z",
    fill: "#FCD728"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.1 92.1C157.481 92.1 158.6 90.9807 158.6 89.6C158.6 88.2193 157.481 87.1 156.1 87.1C154.719 87.1 153.6 88.2193 153.6 89.6C153.6 90.9807 154.719 92.1 156.1 92.1Z",
    fill: "#FCD728"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M167.1 71.1C168.481 71.1 169.6 69.9807 169.6 68.6C169.6 67.2193 168.481 66.1 167.1 66.1C165.719 66.1 164.6 67.2193 164.6 68.6C164.6 69.9807 165.719 71.1 167.1 71.1Z",
    fill: "#FCD728"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M153.1 56.1C154.481 56.1 155.6 54.9807 155.6 53.6C155.6 52.2193 154.481 51.1 153.1 51.1C151.719 51.1 150.6 52.2193 150.6 53.6C150.6 54.9807 151.719 56.1 153.1 56.1Z",
    fill: "#FCD728"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.1 168.1C121.481 168.1 122.6 166.981 122.6 165.6C122.6 164.219 121.481 163.1 120.1 163.1C118.719 163.1 117.6 164.219 117.6 165.6C117.6 166.981 118.719 168.1 120.1 168.1Z",
    fill: "#FCD728"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.1 181.1C134.481 181.1 135.6 179.981 135.6 178.6C135.6 177.219 134.481 176.1 133.1 176.1C131.719 176.1 130.6 177.219 130.6 178.6C130.6 179.981 131.719 181.1 133.1 181.1Z",
    fill: "#FCD728"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M157.6 44.1C159.257 44.1 160.6 43.2046 160.6 42.1C160.6 40.9954 159.257 40.1 157.6 40.1C155.943 40.1 154.6 40.9954 154.6 42.1C154.6 43.2046 155.943 44.1 157.6 44.1Z",
    fill: "#009D00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M161.6 45.1C163.257 45.1 164.6 44.2046 164.6 43.1C164.6 41.9954 163.257 41.1 161.6 41.1C159.943 41.1 158.6 41.9954 158.6 43.1C158.6 44.2046 159.943 45.1 161.6 45.1Z",
    fill: "#009D00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M160.6 48.1C162.257 48.1 163.6 47.2046 163.6 46.1C163.6 44.9954 162.257 44.1 160.6 44.1C158.943 44.1 157.6 44.9954 157.6 46.1C157.6 47.2046 158.943 48.1 160.6 48.1Z",
    fill: "#009D00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.6 49.1C158.257 49.1 159.6 48.2046 159.6 47.1C159.6 45.9954 158.257 45.1 156.6 45.1C154.943 45.1 153.6 45.9954 153.6 47.1C153.6 48.2046 154.943 49.1 156.6 49.1Z",
    fill: "#009D00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M154.6 46.1C156.257 46.1 157.6 45.2046 157.6 44.1C157.6 42.9954 156.257 42.1 154.6 42.1C152.943 42.1 151.6 42.9954 151.6 44.1C151.6 45.2046 152.943 46.1 154.6 46.1Z",
    fill: "#009D00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M157.6 46.1C159.257 46.1 160.6 45.2046 160.6 44.1C160.6 42.9954 159.257 42.1 157.6 42.1C155.943 42.1 154.6 42.9954 154.6 44.1C154.6 45.2046 155.943 46.1 157.6 46.1Z",
    fill: "#009D00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_165",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_165",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_165",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_165",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGmAAACBQAAAtH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACJAAACAwEBAAAAAAAAAAAAAAAEBQABBgIDAQEAAAAAAAAAAAAAAAAAAAAAEAAABgICAwAAAAAAAAAAAAAAAQIEBQYDByAXEBEWEQABAgQDBQYHAAAAAAAAAAABAAIRMQMEIdGSoRKTBTUQQZET0xRRgbFCcmNzEgEAAAAAAAAAAAAAAAAAAAAg/9oADAMBAAIRAxEAAADF6nJ6QbnLuw6VZJBiwvUITI2yk//aAAgBAgABBQDl/9oACAEDAAEFAOX/2gAIAQEAAQUAj4t1ILZ62d5QjWDclFriE9dcQY64gx1xBjriDDnWces3GsVljlao/jSDJb9GRrM3rFjRarmlKLZbyUVvmvX18yPr5kOLbZzM7Xchnn75kXJOrFn8f//aAAgBAgIGPwBf/9oACAEDAgY/AF//2gAIAQEBBj8ADKAAEYEkoOr3AbTI+0Y7YoF928tBxGGOxYl8fyOam/Uc1N+o5qb9RzU36jmgaFd9ICYnHVFE290S/u3wIbIIuc5tRonDA9m9Y+YX/rBdsAKa2laXFRokTb1DHwCAPJbhx+Pk1fTQ3+R3BbHGFGrGHDWPIr2P8H5LoN9wH5LoN9wH5Ie25HdAd+/RqD6MK6JccGr6aJFhcU2GTfb1TD5wCcb9ldjTNrqbmAeI7P/Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_165",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF0AAABgwAAAbD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABoAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAABABAQEBAAAAAAAAAAAAAAAABQAQBBEAAQQDAQAAAAAAAAAAAAAAARESAwQgIWECEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAAACfnw//2gAIAQIAAQUAv//aAAgBAwABBQC//9oACAEBAAEFABDBesvf/9oACAECAgY/AH//2gAIAQMCBj8Af//aAAgBAQEGPwC1NcnZaiU+ArWhNcOH/9k="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemon);
export default __webpack_public_path__ + "static/media/lemon.a89291986f600630d82a084252610703.svg";
export { ForwardRef as ReactComponent };